'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'inbox';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f01c';
var svgPathData = 'M32 448l448 0 0-124.1-1-3.9-101.1 0-27.6 55.2-4.4 8.8-9.9 0-160 0-9.9 0-4.4-8.8L134.1 320 33 320l-1 3.9L32 448zM471 288L415 64 97 64 41 288l103 0 9.9 0 4.4 8.8L185.9 352l140.2 0 27.6-55.2 4.4-8.8 9.9 0 103 0zM0 448L0 320 72 32l368 0 72 288 0 128 0 32-32 0L32 480 0 480l0-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faInbox = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;